import React from "react";

function HeroDeFiLottery() {
  return (
    <div
      className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
      style={{
        background: "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
      }}
    >
      <div className="container">
        <div className="row align-center">
          <div className="col-xl-9 col-lg-8">
            <div className="banner-two-content">
              <h2 className="split-text-right split-text-in-right">
                DeFi Lottery Platform Development
              </h2>
              <div className="info">
                <p className="fade-up-anim">
                  Unlock the future of lottery systems with Xeer Technology’s
                  advanced DeFi lottery platform development services. Combining
                  the excitement of lottery games with the transparency,
                  security, and decentralization of blockchain technology, our
                  DeFi lottery platforms offer a unique, trustless gaming
                  experience that maximizes user engagement and revenue
                  potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroDeFiLottery;
